import { REHYDRATE } from 'redux-persist';

import * as types from '../actions/actionTypes';

const favorites = (state, action) => {
    if (!action.patternid) {
        return state;
    }

    const newItems = (
        state.items || []
    ).slice(0, 99);

    switch (action.type) {

        case types.ADDED_TO_FAVORITES:

            for (let i = 0; i < state.items.length; i++) {
                if (newItems[i] && newItems[i].patternid === action.patternid &&
                    newItems[i].sewpatId === action.sewpatId) {
                    if (action.query.colors === newItems[i].query.colors) {
                        newItems.splice(i, 1);
                    }
                    else if (Object.keys(action.query).length ===
                        0 &&
                        newItems[i].query.length ===
                        0) {
                        newItems.splice(i, 1);
                    }
                }
            }

            newItems.unshift({
                patternid: action.patternid,
                sewpatId: action.sewpatId,
                query: action.query,
                date: action.date,
            });

            return Object.assign({}, state, { items: newItems });

        case types.REMOVED_FROM_FAVORITES:

            for (let i = 0; i < newItems.length; i++) {
                if (newItems[i].patternid === action.patternid &&
                    newItems[i].sewpatId === action.sewpatId) {
                    if (action.query.colors === newItems[i].query.colors) {
                        newItems.splice(i, 1);
                    }
                    else if (Object.keys(action.query).length ===
                        0 &&
                        newItems[i].query.length ===
                        0) {
                        newItems.splice(i, 1);
                    }
                }
            }

            return Object.assign({}, state, { items: newItems });

        case REHYDRATE:
            return state;

        default:
            return state;
    }
};

export default favorites;

export const getFavorites = state => state.stolo.favorites;




// WEBPACK FOOTER //
// ./src/reducers/favorites.js